export const PROGRESS_BAR_TIMES = {
    NEW_ACCOUNT: 8,
    PHONE_NUMBER: 7,
    SELECT_MOBILE_DESKTOP: 7,
    DOCUMENT_SELECTION: 7,
    DATA_UPLOAD_CHOICE: 7,
    WAITING_FOR_MOBILE: 7,
    MOBILE_UPLOAD: 7,
    DESKTOP_UPLOAD: 7,
    LOGIN: 7,
    RETURN_TO_DESKTOP: 7,
    CONFIRM_PHONE: 6,
    PERSONAL_DATA: 6,
    ADDRESS_DETAILS: 6,
    TAX_RESIDENCE: 5,
    CURRENCY: 5,
    RISK_ASSESSMENT: 4,
    DECLARATION_ACCEPTANCE: 4,
    CLIENT_ZONE_LOGIN: 3,
    ACCOUNT_OPEN: 3,
    ONBOARDING_DENIED: 0,
};
